import cn from 'classnames'
import React, { ComponentPropsWithoutRef, forwardRef, Ref } from 'react'

import styles from './ApproveButton.module.scss'

export type ApproveButtonVariant = 'approved' | 'highlight' | 'lavender' | 'secondary'

export interface ApproveButtonProps extends Omit<ComponentPropsWithoutRef<'button'>, 'type' | 'size'> {
  icon?: React.ReactElement
  variant: ApproveButtonVariant
}

function ApproveButton(
  { icon, variant = 'lavender', className, children, ...props }: ApproveButtonProps,
  ref: Ref<HTMLButtonElement>
) {
  return (
    <button ref={ref} className={cn(styles.root, styles[variant])} {...props}>
      <span className={styles.label}>{children}</span>
      {icon && <span className={styles.icon}>{icon}</span>}
    </button>
  )
}

export default forwardRef(ApproveButton)
